import { render, staticRenderFns } from "./AtmTicket.vue?vue&type=template&id=4c86ed01&scoped=true"
import script from "./AtmTicket.vue?vue&type=script&lang=js"
export * from "./AtmTicket.vue?vue&type=script&lang=js"
import style0 from "./AtmTicket.vue?vue&type=style&index=0&id=4c86ed01&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c86ed01",
  null
  
)

export default component.exports